var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('lv-checkbox-group',{attrs:{"options":_vm.options,"color":"success","pulse":_vm.pulse,"outline":"","value":_vm.modelValue},on:{"input":_vm.updateValue}})}
var staticRenderFns = []

export { render, staticRenderFns }